module.exports = __webpack_public_path__ + "static/media/tm-colorit-4.da78c963.webp";